import { render, staticRenderFns } from "./exchange-group-order.vue?vue&type=template&id=70d1f482"
import script from "./exchange-group-order.vue?vue&type=script&lang=js"
export * from "./exchange-group-order.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports